import { createWebHistory, createRouter } from "vue-router";
import { isAuthenticated, hasRole, getCurrentUser } from "@/api/auth";
import { getCachedMenus, refreshMenuCache, isMenuVisible } from "@/api/menus";


const routes= [
  {
    path: "/",
    redirect:'/dashboard/bank-sampah',
  },
  {
    path: "/privacy-policy",
    name: "Privacy Policy",
    component: () => import("@/components/Authentication/PrivacyPolicyComponent.vue"),
    meta: { layout:'guest', domain:"Admin",page_title: "Kebijakan Privasi" },
  },
  {
    path: "/hapus-akun",
    name: "Account Deletion",
    component: () => import("@/components/Authentication/AccountDeletionComponent.vue"),
    meta: { layout:'guest', domain:"Admin",page_title: "Hapus Akun" },
  },
  {
    path: "/reset-password",
    name: "Reset Password Confirm",
    component: () => import("@/components/Authentication/ResetPasswordComponent.vue"),
    meta: { layout:'guest', domain:"Admin",page_title: "Reset Password" },
  },
  {
    path: "/dashboard",
    name: "My Dashboard",
    redirect:'/dashboard/bank-sampah',
    meta: { layout:'auth', domain:"Admin",page_title: 'Index'},
    children: [
      {
        path: "bank-sampah",
        name: "Bank Sampah Dashboard",
        component: () => import("@/components/Dashboard/BankSampahDashboardComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Dashboard" },
      },
      {
        path: "analysis",
        name: "Analysis",
        component: () => import("@/components/Luno-Main/IndexComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Analysis" },
      },
      {
        path: "my-wallet",
        name: "My wallet",
        component: () => import("@/components/Luno-Main/MyWalletComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "My wallet" },
      },
      {
        path: "smart-iot",
        name: "IOT",
        component: () => import("@/components/Luno-Main/SmartIOTComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "IOT" },
      },
    ],
  },
  {
    path: "/applications",
    name: "Applications",
    redirect:'/applications/app-calander',
    meta: { layout:'auth', domain:"Admin",page_title: 'Applications'},
    children: [
      {
        path: "app-calander",
        name: "Calendar",
        component: () => import("@/components/Applications/CalenderComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Calendar" },
      },
      // {
      //   path: "app-tui-calander",
      //   name: "tui Calendar",
      //   component: () => import("@/components/Applications/TuiCalenderComponent.vue"),
      //   meta: { layout:'auth', domain:"Admin",page_title: "tui Calendar" },
      // },
      {
        path: "app-email",
        name: "Email App",
        component: () => import("@/components/Applications/Email/EmailComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Email App" },
      },
      {
        path: "app-email-detail",
        name: "Email-detail",
        component: () => import("@/components/Applications/Email/EmailDetailComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Email Detail" },
      },
      {
        path: "app-email-compose",
        name: "Email-compose",
        component: () => import("@/components/Applications/Email/ComposeEmailComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Email Compose" },
      },
      {
        path: "app-chat",
        name: "Chat app",
        component: () => import("@/components/Applications/ChatComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Chat app" },
      },
      {
        path: "app-campaigns",
        name: "Campaigns",
        component: () => import("@/components/Applications/CampaignComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Campaigns" },
      },
      {
        path: "app-social",
        name: "Social App",
        component: () => import("@/components/Applications/SocialApp/SocialAppComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Social App" },
      },
      {
        path: "app-file-manager",
        name: "File Manager",
        component: () => import("@/components/Applications/FilemanagerComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "File Manager" },
      },
      {
        path: "app-todo",
        name: "Todo App",
        component: () => import("@/components/Applications/TodoComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Todo App" },
      },
      {
        path: "app-contact",
        name: "Contacts",
        component: () => import("@/components/Applications/ContactComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Contacts" },
      },
      {
        path: "app-task",
        name: "Tasks",
        component: () => import("@/components/Applications/TaskComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Tasks" },
      },
      {
        path: "app-project-list",
        name: "Project List",
        component: () => import("@/components/Applications/project/ProjectListComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Project List" },
      },
      {
        path: "app-project-detail",
        name: "Project Detail",
        component: () => import("@/components/Applications/project/ProjectDetailComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Project Detail" },
      },
      {
        path: "app-kanban-board",
        name: "Kanban Board",
        component: () => import("@/components/Applications/KanbanboardComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Kanban Board" },
      },
      {
        path: "app-blog",
        name: "Blog Post",
        component: () => import("@/components/Applications/BlogPostComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Blog Post" },
      },
      {
        path: "app-blog-details",
        name: "Blog Details",
        component: () => import("@/components/Applications/BlogDetailsComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Blog Details" },
      }
    ],
  },
  {
    path: "/crafted-pages",
    name: "Crafted Pages",
    redirect:'/crafted-pages/my-profile',
    meta: { layout:'auth', domain:"Admin",page_title: 'Crafted Pages'},
    children: [
      {
        path: "my-profile",
        name: "My Profile",
        component: () => import("@/components/MorePages/my-profile/MyProfileComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "My Profile" },
      },
      {
        path: "bookmarks",
        name: "Bookmarks",
        component: () => import("@/components/MorePages/BookmarksComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Bookmarks" },
      },
      {
        path: "timeline",
        name: "Timeline",
        component: () => import("@/components/MorePages/TimelineComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Timeline" },
      },
      {
        path: "image-gallery",
        name: "Image Gallery",
        component: () => import("@/components/MorePages/ImageGallaryComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Image Gallery" },
      },
      {
        path: "pricing",
        name: "Pricing",
        component: () => import("@/components/MorePages/PricingComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Pricing" },
      },
      {
        path: "team-board",
        name: "Teams Board",
        component: () => import("@/components/MorePages/TeamBoardComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Teams Board" },
      },
      {
        path: "support-ticket",
        name: "Support Ticket",
        component: () => import("@/components/MorePages/SupportTicketComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Support Ticket" },
      },
      {
        path: "faqs",
        name: "FAQs",
        component: () => import("@/components/MorePages/FAQComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "FAQs" },
      },
      {
        path: "search-pages",
        name: "Search Pages",
        component: () => import("@/components/MorePages/SearchPagesComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Search Pages" },
      },
      {
        path: "footers",
        name: "Footers",
        component: () => import("@/components/MorePages/FootersComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Footers" },
      },
    ]
  },
  {
    path: "/account",
    name: "Account",
    redirect:'/account/settings',
    meta: { layout:'auth', domain:"Admin",page_title: 'Account'},
    children: [
      {
        path: "settings",
        name: "Settings",
        component: () => import("@/components/Account/SettingsComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Settings" },
      },
      {
        path: "invoice-list",
        name: "Invoice List",
        component: () => import("@/components/Account/InvoiceComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Invoice List" },
      },
      {
        path: "invoice-create",
        name: "Create Invoices",
        component: () => import("@/components/Account/CreateInvoiceComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Create Invoices" },
      },
      {
        path: "billing",
        name: "Billing",
        component: () => import("@/components/Account/BillingComponent.vue"),
        meta: { layout:'auth', domain:"Admin",page_title: "Billing" },
      },
    ]
  },
  {
    path: "/authentication",
    name: "Authentication",
    redirect:'/authentication/404',
    meta: { layout:'guest', domain:"Admin",page_title: 'Authentication'},
    children: [
      {
        path: "404",
        name: "404",
        component: () => import("@/components/Authentication/404Component.vue"),
        meta: { layout:'guest', domain:"Admin",page_title: "404" },
      },
      {
        path: "403",
        name: "403",
        component: () => import("@/components/Authentication/403Component.vue"),
        meta: { layout:'guest', domain:"Admin",page_title: "403" },
      },
      {
        path: "500",
        name: "500",
        component: () => import("@/components/Authentication/500Component.vue"),
        meta: { layout:'guest', domain:"Admin",page_title: "500" },
      },
      {
        path: "sign-in",
        name: "Sign in",
        component: () => import("@/components/Authentication/SignInComponent.vue"),
        meta: { layout:'guest', domain:"Admin",page_title: "Sign in" },
      },
      {
        path: "sign-up",
        name: "Sign up",
        component: () => import("@/components/Authentication/SignUpComponent.vue"),
        meta: { layout:'guest', domain:"Admin",page_title: "Sign up" },
      },
      {
        path: "password-reset",
        name: "Password reset",
        component: () => import("@/components/Authentication/PasswordResetComponent.vue"),
        meta: { layout:'guest', domain:"Admin",page_title: "Password reset" },
      },
      {
        path: "2-step-authentication",
        name: "2-Step Authentication",
        component: () => import("@/components/Authentication/TwoStepAuthenticationComponent.vue"),
        meta: { layout:'guest', domain:"Admin",page_title: "2-Step Authentication" },
      },
      {
        path: "lockscreen",
        name: "Lockscreen",
        component: () => import("@/components/Authentication/LockscreenComponent.vue"),
        meta: { layout:'guest', domain:"Admin",page_title: "Lockscreen" },
      },
      {
        path: "maintenance",
        name: "Maintenance",
        component: () => import("@/components/Authentication/MaintenanceComponent.vue"),
        meta: { layout:'guest', domain:"Admin",page_title: "Maintenance" },
      },
    ]
  },
  // {
  //   path: "/layouts",
  //   name: "Layouts",
  //   component: () => import("@/components/Luno-Main/LunoLayoutsComponent.vue"),
  //   meta: { layout:'auth', domain:"Admin",page_title: 'Layouts'},
  // },
  {
    path: "/model-popups",
    name: "Modals Popups",
    component: () => import("@/components/core/ModelsComponent.vue"),
    meta: { layout:'auth', domain:"Admin",page_title: 'Modals Popups'},
  },
  {
    path: "/widgets",
    name: "Widgets",
    redirect:'/documentation/widget-basic-card',
    meta: { layout:'auth', domain:"documentation",page_title: 'Widgets'},
  },
  {
    path: "/documentation",
    name: "Documentation",
    redirect:'/documentation/overview',
    meta: { layout:'auth', domain:"documentation",page_title: 'Documentation'},
    children: [
      {
        path: "overview",
        name: "Overview",
        component: () => import("@/components/documentation/OverviewComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Overview" },
      },
      {
        path: "dev-setup",
        name: "Dev Setup",
        component: () => import("@/components/documentation/DevSetupComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Dev Setup" },
      },
      {
        path: "file-structure",
        name: "File Structure",
        component: () => import("@/components/documentation/FileStructureComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "File Structure" },
      },
      {
        path: "references",
        name: "References",
        component: () => import("@/components/documentation/ReferencesComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "References" },
      },
      {
        path: "helper-class",
        name: "Helper Class",
        component: () => import("@/components/documentation/HelperClassComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Helper Class" },
      },
      {
        path: "stater-page",
        name: "Stater Page",
        component: () => import("@/components/documentation/StaterPageComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Stater Page" },
      },
      {
        path: "animation",
        name: "Animation",
        component: () => import("@/components/documentation/AnimationComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Animation" },
      },
      {
        path: "doc-changelog",
        name: "Changelog",
        component: () => import("@/components/documentation/ChangelogComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Changelog" },
      },
      {
        path: "widget-basic-card",
        name: "Basic Card",
        component: () => import("@/components/documentation/Widgets/BasicCardComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Basic Card" },
      },
      {
        path: "widget-card-tiles",
        name: "Card Tiles",
        component: () => import("@/components/documentation/Widgets/CardTilesComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Card Tiles" },
      },
      {
        path: "widget-user-card",
        name: "User's Card",
        component: () => import("@/components/documentation/Widgets/UsersCardComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "User's Card" },
      },
      {
        path: "widget-tabbed-card",
        name: "Tabbed Card",
        component: () => import("@/components/documentation/Widgets/TabbedCardComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Tabbed Card" },
      },
      {
        path: "widget-card-ribbons",
        name: "Card Ribbons",
        component: () => import("@/components/documentation/Widgets/RibbonsCardComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Card Ribbons" },
      },
      {
        path: "widget-card-list",
        name: "Card List",
        component: () => import("@/components/documentation/Widgets/CardListComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Card List" },
      },
      {
        path: "widget-chart",
        name: "Widget Chart",
        component: () => import("@/components/documentation/Widgets/WidgetChartComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Widget Chart" },
      },
      {
        path: "widget-card-table",
        name: "Card Table",
        component: () => import("@/components/documentation/Widgets/TablesCardComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Card Table" },
      },
      {
        path: "charts-apexchart",
        name: "Apex Chart",
        component: () => import("@/components/documentation/Charts/ApexChartComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Apex Chart" },
      },
      {
        path: "charts-chartjs",
        name: "ChartJS",
        component: () => import("@/components/documentation/Charts/ChartJSComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "ChartJS" },
      },
      {
        path: "charts-roundslider",
        name: "Round Slider",
        component: () => import("@/components/documentation/Charts/RoundSliderComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Round Slider" },
      },
      {
        path: "charts-sparkline",
        name: "Sparkline",
        component: () => import("@/components/documentation/Charts/SparklineComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Sparkline" },
      },
      {
        path: "elements-clipboard",
        name: "Clipboard",
        component: () => import("@/components/documentation/AdvancedElements/ClipboardComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Clipboard" },
      },
      {
        path: "elements-colorpicker",
        name: "Colorpicker",
        component: () => import("@/components/documentation/AdvancedElements/ColorPickerComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Colorpicker" },
      },
      {
        path: "elements-datepicker",
        name: "Datepicker",
        component: () => import("@/components/documentation/AdvancedElements/DatePickerComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Datepicker" },
      },
      {
        path: "elements-dropify",
        name: "Dropify",
        component: () => import("@/components/documentation/AdvancedElements/DropifyComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Dropify" },
      },
      {
        path: "elements-flatpickr",
        name: "Flatpickr",
        component: () => import("@/components/documentation/AdvancedElements/FlatpickrComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Flatpickr" },
      },
      {
        path: "elements-imageinput",
        name: "Image Input",
        component: () => import("@/components/documentation/AdvancedElements/ImageInputComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Image Input" },
      },
      {
        path: "elements-inputmask",
        name: "Inputmask",
        component: () => import("@/components/documentation/AdvancedElements/InputmaskComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Inputmask" },
      },
      {
        path: "elements-slider",
        name: "Slider",
        component: () => import("@/components/documentation/AdvancedElements/SliderComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Slider" },
      },
      {
        path: "elements-passwordmeter",
        name: "Password Meter",
        component: () => import("@/components/documentation/AdvancedElements/PasswordMeterComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Password Meter" },
      },
      {
        path: "elements-sweetalert2",
        name: "Sweetalert2",
        component: () => import("@/components/documentation/AdvancedElements/SweetalertComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Sweetalert 2" },
      },
      {
        path: "elements-tagsinput",
        name: "Tagsinput",
        component: () => import("@/components/documentation/AdvancedElements/TagInputComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Tagsinput" },
      },
      {
        path: "elements-select2",
        name: "Select2",
        component: () => import("@/components/documentation/AdvancedElements/Select2Component.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Select 2" },
      },
      {
        path: "elements-draggable",
        name: "Draggable",
        component: () => import("@/components/documentation/AdvancedElements/DraggableComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Draggable" },
      },
      {
        path: "form-elements-bootstrapform",
        name: "Bootstrap Form",
        component: () => import("@/components/documentation/FormElements/BootstrapFormComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Bootstrap Form" },
      },
      {
        path: "form-elements-wizard-horizontal",
        name: "Form Wizard horizontal",
        component: () => import("@/components/documentation/FormElements/FormWizardhorizontalComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Form Wizard horizontal" },
      },
      {
        path: "form-elements-customform",
        name: "Custom Form",
        component: () => import("@/components/documentation/FormElements/CustomFormComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Custom Form" },
      },
      {
        path: "font-icons-fontawesome",
        name: "Font Awesome",
        component: () => import("@/components/documentation/FontIcons/FontAwesomeComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Font Awesome" },
      },
      {
        path: "font-icons-simpleline",
        name: "Simple line",
        component: () => import("@/components/documentation/FontIcons/SimplelineComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Simple line" },
      },
      {
        path: "font-icons-weathericons",
        name: "Weather Icons",
        component: () => import("@/components/documentation/FontIcons/WeatherIconsComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Weather Icons" },
      },
      {
        path: "font-icons-icons8lineawesome",
        name: "Icons8 Line Awesome",
        component: () => import("@/components/documentation/FontIcons/Icons8LineAwesomeComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Icons8 Line Awesome" },
      },
      {
        path: "font-icons-bootstrapicon",
        name: "Bootstrap Icon",
        component: () => import("@/components/documentation/FontIcons/BootstrapIconComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Bootstrap Icon" },
      },
      {
        path: "font-icons-flagicon",
        name: "Flag Icon",
        component: () => import("@/components/documentation/FontIcons/FlagIconComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Flag Icon" },
      },
      {
        path: "font-icons-svgcustomicon",
        name: "SVG Custom Icon",
        component: () => import("@/components/documentation/FontIcons/SVGCustomIconComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "SVG Custom Icon" },
      },
      {
        path: "plugins-dataTables",
        name: "DataTables",
        component: () => import("@/components/documentation/Plugins/DataTablesComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "DataTables" },
      },
      {
        path: "plugins-editor",
        name: "Editor",
        component: () => import("@/components/documentation/Plugins/EditorComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Editor" },
      },
      {
        path: "plugins-carousel",
        name: "Carousel",
        component: () => import("@/components/documentation/Plugins/CarouselComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Carousel" },
      },
      {
        path: "plugins-typedjs",
        name: "Typed.js",
        component: () => import("@/components/documentation/Plugins/TypedjsComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Typed.js" },
      },
      {
        path: "plugins-fullcalendar",
        name: "Fullcalendar",
        component: () => import("@/components/documentation/Plugins/FullcalendarComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Fullcalendar" },
      },
      {
        path: "plugins-cropper",
        name: "Cropper",
        component: () => import("@/components/documentation/Plugins/CropperComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Cropper" },
      },
      {
        path: "plugins-bootstrapsubmenu",
        name: "Bootstrap submenu",
        component: () => import("@/components/documentation/Plugins/BootstrapsubmenuComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Bootstrap submenu" },
      },
      {
        path: "bootstrap-alerts",
        name: "Alerts",
        component: () => import("@/components/documentation/Bootstrap/AlertsComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Alerts" },
      },
      {
        path: "bootstrap-avatar",
        name: "Avatar",
        component: () => import("@/components/documentation/Bootstrap/AvatarComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Avatar" },
      },
      {
        path: "bootstrap-badge",
        name: "Badge",
        component: () => import("@/components/documentation/Bootstrap/BadgeComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Badge" },
      },
      {
        path: "bootstrap-borders",
        name: "Borders",
        component: () => import("@/components/documentation/Bootstrap/BordersComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Borders" },
      },
      {
        path: "bootstrap-breadcrumb",
        name: "Breadcrumb",
        component: () => import("@/components/documentation/Bootstrap/BreadcrumbsComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Breadcrumb" },
      },
      {
        path: "bootstrap-buttons",
        name: "Buttons",
        component: () => import("@/components/documentation/Bootstrap/ButtonsComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Buttons" },
      },
      {
        path: "bootstrap-card",
        name: "Card",
        component: () => import("@/components/documentation/Bootstrap/CardComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Card" },
      },
      {
        path: "bootstrap-carousel",
        name: "Bootstrap Carousel",
        component: () => import("@/components/documentation/Bootstrap/CarouselComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Bootstrap Carousel" },
      },
      {
        path: "bootstrap-collapse",
        name: "Collapse",
        component: () => import("@/components/documentation/Bootstrap/CollapseComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Collapse" },
      },
      {
        path: "bootstrap-dropdown",
        name: "Dropdowns",
        component: () => import("@/components/documentation/Bootstrap/DropdownComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Dropdowns" },
      },
      {
        path: "bootstrap-listgroup",
        name: "List group",
        component: () => import("@/components/documentation/Bootstrap/ListgroupComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "List group" },
      },
      {
        path: "bootstrap-modal",
        name: "Modal",
        component: () => import("@/components/documentation/Bootstrap/ModalComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Modal" },
      },
      {
        path: "bootstrap-navbar",
        name: "Navbar",
        component: () => import("@/components/documentation/Bootstrap/NavbarComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Navbar" },
      },
      {
        path: "bootstrap-navs",
        name: "Navs",
        component: () => import("@/components/documentation/Bootstrap/NavsComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Navs" },
      },
      {
        path: "bootstrap-pagination",
        name: "Pagination",
        component: () => import("@/components/documentation/Bootstrap/PaginationComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Pagination" },
      },
      {
        path: "bootstrap-progress",
        name: "Progress",
        component: () => import("@/components/documentation/Bootstrap/ProgressComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Progress" },
      },
      {
        path: "bootstrap-scrollspy",
        name: "Scrollspy",
        component: () => import("@/components/documentation/Bootstrap/ScrollspyComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Scrollspy" },
      },
      {
        path: "bootstrap-spinners",
        name: "Spinners",
        component: () => import("@/components/documentation/Bootstrap/SpinnersComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Spinners" },
      },
      {
        path: "bootstrap-toasts",
        name: "Toasts",
        component: () => import("@/components/documentation/Bootstrap/ToastsComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Toasts" },
      },
      {
        path: "bootstrap-thankyou",
        name: "Thank You!",
        component: () => import("@/components/documentation/Bootstrap/ThankYouComponent.vue"),
        meta: { layout:'auth', domain:"documentation",page_title: "Thank You!" },
      }
    ]
  },
  {
    path: "/changelog",
    redirect:'/documentation/doc-changelog',
  },
  {
    path: "/nasabah",
    name: "Nasabah",
    redirect: '/nasabah/list',
    meta: { layout:'auth', domain:"Admin", page_title: 'Nasabah', menuKode: 'nasabah' },
    children: [
      {
        path: "list",
        name: "Nasabah List",
        component: () => import("@/components/Nasabah/NasabahListComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Data Nasabah" },
      },
      {
        path: ":id",
        name: "Nasabah Detail",
        component: () => import("@/components/Nasabah/NasabahDetailComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Detail Nasabah" },
      },
    ],
  },
  {
    path: "/registrasi-nasabah",
    name: "Registrasi Nasabah",
    redirect: '/registrasi-nasabah/list',
    meta: { layout:'auth', domain:"Admin", page_title: 'Pendaftaran Nasabah', menuKode: 'registrasi-nasabah' },
    children: [
      {
        path: "list",
        name: "Registrasi Nasabah List",
        component: () => import("@/components/Nasabah/RegistrasiNasabahListComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Pendaftaran Nasabah" },
      },
    ],
  },
  {
    path: "/akun-saya",
    name: "Akun Saya",
    component: () => import("@/components/Nasabah/AkunSayaComponent.vue"),
    meta: { layout:'auth', domain:"Admin", page_title: "Akun Saya" },
  },
  {
    path: "/master-sampah",
    name: "Master Sampah",
    redirect: '/master-sampah/list',
    meta: { layout:'auth', domain:"Admin", page_title: 'Master Kategori Sampah', menuKode: 'master-sampah' },
    children: [
      {
        path: "list",
        name: "Master Sampah List",
        component: () => import("@/components/MasterSampah/KategoriSampahListComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Master Kategori Sampah" },
      },
    ],
  },
  {
    path: "/pengumuman",
    name: "Pengumuman",
    redirect: '/pengumuman/list',
    meta: { layout:'auth', domain:"Admin", page_title: 'Pengumuman', menuKode: 'pengumuman' },
    children: [
      {
        path: "list",
        name: "Pengumuman List",
        component: () => import("@/components/Pengumuman/PengumumanListComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Pengumuman" },
      },
    ],
  },
  {
    path: "/transaksi-setoran",
    name: "Transaksi Setoran",
    redirect: '/transaksi-setoran/list',
    meta: { layout:'auth', domain:"Admin", page_title: 'Transaksi Setoran', menuKode: 'transaksi-setoran' },
    children: [
      {
        path: "list",
        name: "Transaksi Setoran List",
        component: () => import("@/components/TransaksiSetoran/TransaksiSetoranListComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Transaksi Setoran" },
      },
      {
        path: "create",
        name: "Transaksi Setoran Create",
        component: () => import("@/components/TransaksiSetoran/TransaksiSetoranFormComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Setoran Baru" },
      },
      {
        path: ":id/struk",
        name: "Transaksi Setoran Struk",
        component: () => import("@/components/TransaksiSetoran/StrukSetoranComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Struk Setoran" },
      },
    ],
  },
  {
    path: "/penarikan",
    name: "Penarikan",
    redirect: '/penarikan/list',
    meta: { layout:'auth', domain:"Admin", page_title: 'Penarikan Saldo', menuKode: 'penarikan' },
    children: [
      {
        path: "list",
        name: "Penarikan List",
        component: () => import("@/components/Penarikan/PenarikanListComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Penarikan Saldo" },
      },
      {
        path: "create",
        name: "Penarikan Create",
        component: () => import("@/components/Penarikan/PenarikanFormComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Penarikan Baru" },
      },
      {
        path: ":id/bukti",
        name: "Penarikan Bukti",
        component: () => import("@/components/Penarikan/BuktiPenarikanComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Bukti Penarikan" },
      },
    ],
  },
  {
    path: "/penarikan-pengajuan",
    name: "Penarikan Pengajuan",
    redirect: '/penarikan-pengajuan/list',
    meta: { layout:'auth', domain:"Admin", page_title: 'Persetujuan Penarikan', menuKode: 'penarikan-pengajuan' },
    children: [
      {
        path: "list",
        name: "Penarikan Pengajuan List",
        component: () => import("@/components/Penarikan/PenarikanPengajuanListComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Persetujuan Penarikan" },
      },
    ],
  },
  {
    path: "/penyesuaian-saldo",
    name: "Penyesuaian Saldo",
    redirect: '/penyesuaian-saldo/list',
    meta: { layout:'auth', domain:"Admin", page_title: 'Penyesuaian Saldo', menuKode: 'penyesuaian-saldo' },
    children: [
      {
        path: "list",
        name: "Penyesuaian Saldo List",
        component: () => import("@/components/PenyesuaianSaldo/PenyesuaianSaldoListComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Penyesuaian Saldo" },
      },
      {
        path: "create",
        name: "Penyesuaian Saldo Create",
        component: () => import("@/components/PenyesuaianSaldo/PenyesuaianSaldoFormComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Penyesuaian Saldo Baru" },
      },
    ],
  },
  {
    path: "/kas",
    name: "Kas",
    redirect: '/kas/ringkasan',
    meta: { layout:'auth', domain:"Admin", page_title: 'Kas', menuKode: 'kas' },
    children: [
      {
        path: "ringkasan",
        name: "Kas Ringkasan",
        component: () => import("@/components/Kas/KasRingkasanComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Kas" },
      },
    ],
  },
  {
    path: "/penjualan-sampah",
    name: "Penjualan Sampah",
    redirect: '/penjualan-sampah/list',
    meta: { layout:'auth', domain:"Admin", page_title: 'Penjualan Sampah', menuKode: 'penjualan-sampah' },
    children: [
      {
        path: "list",
        name: "Penjualan Sampah List",
        component: () => import("@/components/PenjualanSampah/PenjualanSampahListComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Penjualan ke Pengepul" },
      },
      {
        path: "create",
        name: "Penjualan Sampah Create",
        component: () => import("@/components/PenjualanSampah/PenjualanSampahFormComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Penjualan Baru" },
      },
      {
        path: ":id/struk",
        name: "Penjualan Sampah Struk",
        component: () => import("@/components/PenjualanSampah/StrukPenjualanComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Struk Penjualan" },
      },
      {
        path: ":id/print",
        name: "Penjualan Sampah Print",
        component: () => import("@/components/PenjualanSampah/StrukPenjualanPrintComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Cetak Struk Penjualan" },
      },
    ],
  },
  {
    path: "/laporan",
    name: "Laporan",
    redirect: '/laporan/nasabah',
    meta: { layout:'auth', domain:"Admin", page_title: 'Laporan', menuKode: 'laporan' },
    children: [
      {
        path: "nasabah",
        name: "Laporan Nasabah",
        component: () => import("@/components/Laporan/LaporanNasabahComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Laporan Nasabah" },
      },
      {
        path: "sampah",
        name: "Laporan Sampah",
        component: () => import("@/components/Laporan/LaporanSampahComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Laporan Sampah" },
      },
      {
        path: "setoran",
        name: "Laporan Setoran",
        component: () => import("@/components/Laporan/LaporanSetoranComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Laporan Setoran" },
      },
      {
        path: "keuangan",
        name: "Laporan Keuangan",
        component: () => import("@/components/Laporan/LaporanKeuanganComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Laporan Keuangan" },
      },
    ],
  },
  {
    path: "/user-management",
    name: "User Management",
    redirect: '/user-management/list',
    meta: { layout:'auth', domain:"Admin", page_title: 'User Management', roles: ['superadmin'] },
    children: [
      {
        path: "list",
        name: "User Management List",
        component: () => import("@/components/UserManagement/UserListComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "User Management", roles: ['superadmin'] },
      },
    ],
  },
  {
    path: "/menu-management",
    name: "Menu Management",
    redirect: '/menu-management/list',
    meta: { layout:'auth', domain:"Admin", page_title: 'Menu Management', roles: ['superadmin'] },
    children: [
      {
        path: "list",
        name: "Menu Management List",
        component: () => import("@/components/MenuManagement/MenuManagementListComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Menu Management", roles: ['superadmin'] },
      },
    ],
  },
  {
    path: "/audit-trail",
    name: "Audit Trail",
    redirect: '/audit-trail/list',
    meta: { layout:'auth', domain:"Admin", page_title: 'Audit Trail', roles: ['superadmin'] },
    children: [
      {
        path: "list",
        name: "Audit Trail List",
        component: () => import("@/components/AuditTrail/AuditTrailListComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Audit Trail", roles: ['superadmin'] },
      },
    ],
  },
  {
    path: "/role-management",
    name: "Role Management",
    redirect: '/role-management/list',
    meta: { layout:'auth', domain:"Admin", page_title: 'Role Management', roles: ['superadmin'] },
    children: [
      {
        path: "list",
        name: "Role Management List",
        component: () => import("@/components/RoleManagement/RoleManagementListComponent.vue"),
        meta: { layout:'auth', domain:"Admin", page_title: "Role Management", roles: ['superadmin'] },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/authentication/404'
  }
]
const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  document.title = ':: Vila Bogor Indah 6 :: '+ to.meta.page_title;

  const isGuestPage = to.meta.layout === 'guest';
  if (!isGuestPage && !isAuthenticated()) {
    return next({ path: '/authentication/sign-in', query: { redirect: to.fullPath } });
  }
  if (isAuthenticated() && getCurrentUser()?.role === 'nasabah' && !isGuestPage && to.path !== '/akun-saya') {
    return next('/akun-saya');
  }
  if (to.meta.roles && !hasRole(...to.meta.roles)) {
    return next('/authentication/403');
  }
  if (isAuthenticated() && getCachedMenus().length === 0) {
    await refreshMenuCache();
  }
  if (to.meta.menuKode && !isMenuVisible(to.meta.menuKode, getCurrentUser()?.roles)) {
    return next('/authentication/404');
  }
  next();
});

export default router;